import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { ShippingCarrierService } from '@app/core/shipping-carriers/services/shipping-carrier.service';

@Component({
  selector: 'filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss'],
})
export class FilterTagsComponent implements OnInit {
  constructor(public tagSvc :ProductTagService) {}

  @Input() value :number[];
  @Input() label :string;
  @Output() changeTags :EventEmitter<number[]> = new EventEmitter<number[]>();

  ngOnInit() :void {
    this.tagSvc.getTags({ parent_only: true }, null);
  }

  onChange() {
    this.changeTags.emit(this.value);
  }

  trackClientByFn(item :any) {
    return item.id;
  }

  customTagsSearchFn(term :any, item :any) {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }
}
